import { element, elementsOf, globalEvent } from '@shared/easyfy.core';
import { GetSubscriptionFlyoutViewForProductList } from '@clientWebServices/productoptions.service';

export default class SubscriptionHelper {
  static Instance: SubscriptionHelper;

  constructor() {
    SubscriptionHelper.Instance = this;
    globalEvent({
      type: 'click',
      events: [
        {
          action: 'subscribe',
          callback: this.loadSubscriptionFlyout,
        },
      ],
    });
  }

  loadSubscriptionFlyout = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const closeVariantSelector = new CustomEvent('close-variant-selector');
    document.dispatchEvent(closeVariantSelector);

    const button: HTMLElement = e.target as HTMLElement;
    const productId = button.getAttribute('data-productId');

    const parent: HTMLElement = button.closest('[data-container="product-card"]') ?? button.closest('[data-container="product"]');
    const selectedVariant: HTMLElement = parent ? elementsOf(parent, '[data-container="selected-variant"]') : null;
    const variantId = selectedVariant?.getAttribute('data-value');
    const flyout = element(`[data-container="product-options-selector-subscription-${productId}"]`) ?? false;

    if (button && productId) {
      if (!flyout) {
        GetSubscriptionFlyoutViewForProductList(productId, variantId)
          .then((res) => {
            if (res?.data?.success && res?.data?.partialHtml != null) {
              const content = document.createRange().createContextualFragment(res?.data?.partialHtml).firstElementChild;
              document.querySelector('body').appendChild(content);
              document.body.classList.add('noof');
              content.setAttribute('toggle-open', '');
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        flyout.setAttribute('toggle-open', '');
      }
    }

    return false;
  };
}
